import { useState } from "react";
import Input from "../Input/Input";
import Button from "../Button/Button";
import Divider from "../Divider/Divider";

export default function MarkAsPurchasedForm({ onSubmit, onCancel }) {
    const [purchaserName, setPurchaserName] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!purchaserName.trim()) return;
        onSubmit(purchaserName);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <h1 className="text-xl font-bold mb-2">Mark as Purchased</h1>
            <Divider />

            <Input
                label="Your Name"
                name="purchaserName"
                value={purchaserName}
                onChange={(e) => setPurchaserName(e.target.value)}
                placeholder="Enter your name"
                required
            />

            <p className="text-sm mb-2">This <span className="font-bold">will not</span> notify the recipient that you are the purchaser.</p>

            <div className="flex justify-end gap-3 pt-2">
                <Button variant="ghost" onClick={onCancel}>Cancel</Button>
                <Button type="submit" variant="primary">Submit</Button>
            </div>
        </form>
    );
}
